import { defineComponent as _defineComponent } from 'vue'
import { useSlots, withDefaults, computed } from "vue";
// @ts-ignore
import { useRouter } from "vue-router/composables";
import BaseButton from "@/components-UI/BaseButton.vue";
import BackArrow from "@/assets/icons/short-back-arrow.svg";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePageLayout',
  props: {
    title: null,
    backRoute: null,
    nudgeTop: null,
    isBackButton: { type: Boolean, default: true },
    sticky: { type: [String, Boolean], default: 'header' },
    isInnerScroll: { type: Boolean },
    isFooterAltStyle: { type: Boolean }
  },
  emits: [
    'back',
    'click-title',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { title?: string, backRoute?: string, nudgeTop?: number, isBackButton: boolean, sticky: string | boolean, isInnerScroll?: boolean, isFooterAltStyle?: boolean }

// @ts-ignore


const router = useRouter();
const slots = useSlots();

const getStickyClasses = computed<string>(() => {
    if (typeof props.sticky === 'string') {
        const sticky = props.sticky.replace(' ', '').split(',');
        const classesArr: string[] = [];

        if (sticky.includes('header')) classesArr.push('--is-sticky-header');
        if (sticky.includes('footer')) classesArr.push('--is-sticky-footer');
        
        return classesArr.join(' ');
    }

    return '';
});

const getClasses = computed<string[]>(() => {
    return [
        (props.sticky && !props.isInnerScroll) && getStickyClasses.value,
        (props.isInnerScroll && !props.sticky) && '--is-inner-scroll',
        props.isFooterAltStyle && '--is-footer-alt-style',
        !props.isBackButton && '--is-hidden-back-button',
    ];
});

const goBack = () => {
    if (props.backRoute) {
        getBackAction();
    } else {
        emits('back');
    }
};

const getBackAction = () => {
    const lastRoute = store.state.beforeLastRoute;
    if (lastRoute === '/') {
        router.push({ path: props.backRoute });
    } else {
        router.back();
    }
};

return { __sfc: true,props, emits, router, slots, getStickyClasses, getClasses, goBack, getBackAction, BaseButton, BackArrow }
}

})